import React from 'react';

const ListSekolahIIT2024: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-2xl font-semibold mb-4">🏫 Deretan Sekolah Asal Peserta IIT Challenge 2024</h2>
            <p className="mb-4">
                <b>IIT Challenge 2024</b> kembali membuktikan semangat generasi muda Indonesia dalam berinovasi lewat teknologi. Ratusan peserta dari berbagai daerah dan jenjang pendidikan turut meramaikan ajang ini, membuktikan bahwa semangat belajar dan berkarya tidak mengenal batas wilayah.
            </p>

            <h3 className="text-xl font-semibold mb-2">🌟 Peserta Datang dari Berbagai Sekolah Terbaik di Indonesia</h3>
            <ul className="list-disc pl-6 mb-4 columns-1 md:columns-2 gap-8">
                <li>SMPK 2 Penabur</li>
                <li>SMPK 5 Penabur Cipinang</li>
                <li>SMP BPK Penabur Tasikmalaya</li>
                <li>SMP Kristen Yahya</li>
                <li>SMP Kristen Kalam Kudus Jayapura</li>
                <li>SMPK 1 BPK Penabur</li>
                <li>Menlo Park School</li>
                <li>SMP Negeri 252 Jakarta</li>
                <li>Springfield International School Permata Buana</li>
                <li>Sekolah Kristen Kalam Kudus Green Garden</li>
                <li>SDK 1 Penabur</li>
                <li>SDK 2 Penabur</li>
                <li>SDK 3 Penabur</li>
                <li>SDK 6 Penabur</li>
                <li>SDK 11 Penabur</li>
                <li>SMA Santo Aloysius 1</li>
                <li>SMP Santo Kristoforus 1</li>
                <li>Nafiri Studi Center</li>
                <li>PKBM Piwulang Becik</li>
                <li>SMAS Kristen Immanuel</li>
                <li>SMAK 7 Penabur</li>
                <li>SMA Bunda Hati Kudus</li>
                <li>SMP Santa Angela</li>
                <li>SDK Penabur Gading Serpong</li>
                <li>SDK Penabur Summarecon Bekasi</li>
                <li>SDK Penabur Kota Wisata</li>
                <li>SD Pelita Fajar</li>
                <li>SD Harapan Kasih</li>
                <li>SMAK 4 Penabur</li>
                <li>SMPK Penabur Gading Serpong</li>
                <li>SMA Santo Kristoforus 1</li>
                <li>Binus School Simprug</li>
                <li>SMA Nasional Plus BPK Penabur Bogor</li>
                <li>Global Sevilla Pulomas</li>
                <li>SMA Labschool Kebayoran</li>
                <li>SMAN 2 Depok</li>
                <li>MTsN 4 Jakarta</li>
                <li>SMAK 5 Penabur</li>
                <li>SMAK 1 BPK Penabur Jakarta</li>
                <li>Penabur Secondary Kelapa Gading</li>
                <li>Global Prestasi Junior High School</li>
                <li>Sekolah Kuntum Cemerlang</li>
                <li>MTsN 5 Jakarta</li>
            </ul>
            <p className="mb-6">
                Dan masih banyak lagi sekolah dari berbagai provinsi lainnya yang menunjukkan prestasi luar biasa di ajang ini!
            </p>

            <h3 className="text-xl font-semibold mb-2">💬 Kolaborasi dan Kompetisi Sehat</h3>
            <p className="mb-4">
                Partisipasi dari sekolah-sekolah ini membentuk suasana kompetisi yang tidak hanya kompetitif, tapi juga kolaboratif dan inspiratif. Para peserta saling belajar satu sama lain, bertukar ide, dan tumbuh bersama sebagai inovator muda.
            </p>

            <h3 className="text-xl font-semibold mb-2">👏 Terima Kasih atas Partisipasinya</h3>
            <p>
                Kami mengucapkan terima kasih kepada seluruh sekolah yang telah mendukung siswa-siswinya untuk ikut serta. Semoga partisipasi tahun ini menjadi langkah awal menuju prestasi yang lebih besar lagi!
            </p>
        </div>
      );
      
};

export default ListSekolahIIT2024;